import React from "react";
import { Box, Button, Typography } from "@mui/material";

export default function ChangeUserInfoButton({
  data,
  nameCheck,
  email2Check,
  userClass,
  mailNotification,
}) {
  const isChanged =
    data?.name !== nameCheck ||
    data?.email2 !== email2Check ||
    data?.admin_flag !== userClass ||
    data?.notification_flag !== mailNotification;

  return (
    <Box textAlign="center">
      <Button
        type={isChanged ? "submit" : "button"}
        variant="contained"
        disabled={!isChanged}
        sx={{
          marginTop: "30px",
          color: "white",
          fontSize: "14px",
          fontWeight: "bold",
          borderRadius: "25px",
          width: "180px",
          backgroundColor: isChanged ? "#28345e" : "#B2B2B2",
          "&:hover": {
            backgroundColor: isChanged ? "#8bb6c6" : "#B2B2B2",
          },
          "&.Mui-disabled": {
            backgroundColor: "#B2B2B2",
            color: "white",
          },
        }}
      >
        <Typography
          sx={{
            fontSize: 14,
            my: "10px",
          }}
          fontWeight="bold"
        >
          保存
        </Typography>
      </Button>
    </Box>
  );
}